module.exports = __webpack_public_path__ + "media/images/visa-0ac4c6ef95dfee8f1a5d3b9b2dad6e18.png";